import { NotesApp } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import AppleNotesIcon from "@/assets/images/onboarding/apple-notes.png";
import ObsidianIcon from "@/assets/images/onboarding/obsidian-icon.png";
import OtherAppIcon from "@/assets/images/onboarding/other-app-icon.png";

export const NotesApps: NotesApp[] = [
  {
    id: "apple-notes",
    title: "Apple Notes",
    iconImage: AppleNotesIcon,
  },
  {
    id: "obsidian",
    title: "Obsidian",
    iconImage: ObsidianIcon,
  },
  {
    id: "other",
    title: "Other",
    iconImage: OtherAppIcon,
  },
] as const;
